/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FBS Adapter
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from "@tanstack/react-query";

import type {
  AgencyBranch,
  AuthenticatedPatronV10,
  AuthenticatedPatronV4,
  AuthenticatedPatronV8,
  AvailabilityV3,
  CreatePatronRequestV7,
  CreateReservationBatch,
  CreateReservationBatchV2,
  DeleteReservationsParams,
  FeeV2,
  GetAvailabilityV3Params,
  GetBranchesParams,
  GetFeesV2Params,
  GetHoldingsLogisticsV1Params,
  HoldingsForBibliographicalRecordLogisticsV1,
  LoanV2,
  PatronWithGuardianRequest,
  RenewedLoanV2,
  ReservationDetails,
  ReservationDetailsV2,
  ReservationResponseV2,
  UpdateGuardianRequest,
  UpdatePatronRequestV3,
  UpdatePatronRequestV6,
  UpdateReservationBatch
} from "./model";

import { mutator } from "./mutator/mutator";
import type { ErrorType, BodyType } from "./mutator/mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getGetBranchesUrl = (params?: GetBranchesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["exclude"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/external/v1/agencyid/branches?${stringifiedParams}`
    : `/external/v1/agencyid/branches`;
};

/**
 *
 *  Returns array of branches.
 *  <p>Can be used for giving the patron the option of choosing a preferred branch or where to pick up
 *  reservations.</p>
 * @summary Get branches for an agency.
 */
export const getBranches = async (
  params?: GetBranchesParams,
  options?: Parameters<typeof mutator>[1]
): Promise<AgencyBranch[]> => {
  return mutator<AgencyBranch[]>(getGetBranchesUrl(params), {
    ...options,
    method: "GET"
  });
};

export const getGetBranchesQueryKey = (params?: GetBranchesParams) => {
  return [
    `/external/v1/agencyid/branches`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetBranchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<void>
>(
  params?: GetBranchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBranches>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranches>>> = ({
    signal
  }) => getBranches(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBranchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBranches>>
>;
export type GetBranchesQueryError = ErrorType<void>;

export function useGetBranches<
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<void>
>(
  params: undefined | GetBranchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBranches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBranches>>,
          TError,
          Awaited<ReturnType<typeof getBranches>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBranches<
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<void>
>(
  params?: GetBranchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBranches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBranches>>,
          TError,
          Awaited<ReturnType<typeof getBranches>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBranches<
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<void>
>(
  params?: GetBranchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBranches>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get branches for an agency.
 */

export function useGetBranches<
  TData = Awaited<ReturnType<typeof getBranches>>,
  TError = ErrorType<void>
>(
  params?: GetBranchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBranches>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBranchesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteReservationsUrl = (params: DeleteReservationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["reservationid"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/external/v1/agencyid/patrons/patronid/reservations?${stringifiedParams}`
    : `/external/v1/agencyid/patrons/patronid/reservations`;
};

/**
 * @summary Delete existing reservations.
 */
export const deleteReservations = async (
  params: DeleteReservationsParams,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  return mutator<void>(getDeleteReservationsUrl(params), {
    ...options,
    method: "DELETE"
  });
};

export const getDeleteReservationsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReservations>>,
    TError,
    { params: DeleteReservationsParams },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReservations>>,
  TError,
  { params: DeleteReservationsParams },
  TContext
> => {
  const mutationKey = ["deleteReservations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReservations>>,
    { params: DeleteReservationsParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteReservations(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReservationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReservations>>
>;

export type DeleteReservationsMutationError = ErrorType<void>;

/**
 * @summary Delete existing reservations.
 */
export const useDeleteReservations = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReservations>>,
      TError,
      { params: DeleteReservationsParams },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReservations>>,
  TError,
  { params: DeleteReservationsParams },
  TContext
> => {
  return useMutation(
    getDeleteReservationsMutationOptions(options),
    queryClient
  );
};

export const getGetReservationsUrl = () => {
  return `/external/v1/agencyid/patrons/patronid/reservations`;
};

/**
 *
 *  Returns an array of reservation details.
 *  <p>When the patron picks up the reserved materials,
 *  the reservation will no longer be returned.
 *  Expired or deleted reservations will not be returned.</p>
 *
 *  The response contains reservation state, which can be any of these values:
 *  <ul>
 *      <li>- reserved</li>
 *      <li>- readyForPickup</li>
 *      <li>- interLibraryReservation</li>
 *      <li>- inTransit</li>
 *      <li>- other</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'
 *  .</p>
 *  The response contains loanType, which can be any of these values:
 *  <ul>
 *      <li>- loan</li>
 *      <li>- interLibraryLoan</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'loan'
 *  .</p>
 * @summary Get all unfulfilled reservations made by the patron (DEPRECATED).
 */
export const getReservations = async (
  options?: Parameters<typeof mutator>[1]
): Promise<ReservationDetails[]> => {
  return mutator<ReservationDetails[]>(getGetReservationsUrl(), {
    ...options,
    method: "GET"
  });
};

export const getGetReservationsQueryKey = () => {
  return [`/external/v1/agencyid/patrons/patronid/reservations`] as const;
};

export const getGetReservationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<void>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReservations>>, TError, TData>
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReservationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReservations>>> = ({
    signal
  }) => getReservations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReservations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReservationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReservations>>
>;
export type GetReservationsQueryError = ErrorType<void>;

export function useGetReservations<
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<void>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReservations>>,
          TError,
          Awaited<ReturnType<typeof getReservations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReservations<
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReservations>>,
          TError,
          Awaited<ReturnType<typeof getReservations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReservations<
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all unfulfilled reservations made by the patron (DEPRECATED).
 */

export function useGetReservations<
  TData = Awaited<ReturnType<typeof getReservations>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReservationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAddReservationsDeprecatedUrl = () => {
  return `/external/v1/agencyid/patrons/patronid/reservations`;
};

/**
 *
 *  Returns an array of reservation details for the created reservations.
 *  <p></p>
 *  The response contains reservation state, which can be any of these values:
 *  <ul>
 *      <li>- reserved</li>
 *      <li>- readyForPickup</li>
 *      <li>- interLibraryReservation</li>
 *      <li>- inTransit</li>
 *      <li>- other</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'.</p>
 *  The response contains loanType, which can be any of these values:
 *  <ul>
 *      <li>- loan</li>
 *      <li>- interLibraryLoan</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'
 *  .</p>
 *  <p>
 *      When making a reservation of a periodical, the values to put in the PeriodicalReservation structure can be obtained
 *      from the periodical information retrieved with the Catalog service.
 *  </p>
 *  <p><b>This method has been deprecated use /external/v1/{agencyid}/patrons/{patronid}/reservations/v2 instead</b></p>
 * @summary Create new reservations for the patron (DEPRECATED).
 */
export const addReservationsDeprecated = async (
  createReservationBatch: CreateReservationBatch,
  options?: Parameters<typeof mutator>[1]
): Promise<ReservationDetails[]> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<ReservationDetails[]>(getAddReservationsDeprecatedUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(createReservationBatch)
  });
};

export const getAddReservationsDeprecatedMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addReservationsDeprecated>>,
    TError,
    { data: BodyType<CreateReservationBatch> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addReservationsDeprecated>>,
  TError,
  { data: BodyType<CreateReservationBatch> },
  TContext
> => {
  const mutationKey = ["addReservationsDeprecated"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addReservationsDeprecated>>,
    { data: BodyType<CreateReservationBatch> }
  > = (props) => {
    const { data } = props ?? {};

    return addReservationsDeprecated(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddReservationsDeprecatedMutationResult = NonNullable<
  Awaited<ReturnType<typeof addReservationsDeprecated>>
>;
export type AddReservationsDeprecatedMutationBody =
  BodyType<CreateReservationBatch>;
export type AddReservationsDeprecatedMutationError = ErrorType<void>;

/**
 * @summary Create new reservations for the patron (DEPRECATED).
 */
export const useAddReservationsDeprecated = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addReservationsDeprecated>>,
      TError,
      { data: BodyType<CreateReservationBatch> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addReservationsDeprecated>>,
  TError,
  { data: BodyType<CreateReservationBatch> },
  TContext
> => {
  return useMutation(
    getAddReservationsDeprecatedMutationOptions(options),
    queryClient
  );
};

export const getUpdateReservationsUrl = () => {
  return `/external/v1/agencyid/patrons/patronid/reservations`;
};

/**
 *
 *  Returns an array of the updated reservation details.
 *  <p></p>
 *  The response contains reservation state, which can be any of these values:
 *  <ul>
 *      <li>- reserved</li>
 *      <li>- readyForPickup</li>
 *      <li>- interLibraryReservation</li>
 *      <li>- inTransit</li>
 *      <li>- other</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'.</p>
 *  The response contains loanType, which can be any of these values:
 *  <ul>
 *      <li>- loan</li>
 *      <li>- interLibraryLoan</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'
 *  .</p>
 * @summary Update existing reservations.
 */
export const updateReservations = async (
  updateReservationBatch: UpdateReservationBatch,
  options?: Parameters<typeof mutator>[1]
): Promise<ReservationDetails[]> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<ReservationDetails[]>(getUpdateReservationsUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(updateReservationBatch)
  });
};

export const getUpdateReservationsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReservations>>,
    TError,
    { data: BodyType<UpdateReservationBatch> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReservations>>,
  TError,
  { data: BodyType<UpdateReservationBatch> },
  TContext
> => {
  const mutationKey = ["updateReservations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReservations>>,
    { data: BodyType<UpdateReservationBatch> }
  > = (props) => {
    const { data } = props ?? {};

    return updateReservations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReservationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReservations>>
>;
export type UpdateReservationsMutationBody = BodyType<UpdateReservationBatch>;
export type UpdateReservationsMutationError = ErrorType<void>;

/**
 * @summary Update existing reservations.
 */
export const useUpdateReservations = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReservations>>,
      TError,
      { data: BodyType<UpdateReservationBatch> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReservations>>,
  TError,
  { data: BodyType<UpdateReservationBatch> },
  TContext
> => {
  return useMutation(
    getUpdateReservationsMutationOptions(options),
    queryClient
  );
};

export const getGetReservationsV2Url = () => {
  return `/external/v1/agencyid/patrons/patronid/reservations/v2`;
};

/**
 *
 *  Returns an array of reservation details.
 *  <p>When the patron picks up the reserved materials,
 *  the reservation will no longer be returned.
 *  Expired or deleted reservations will not be returned.</p>
 *
 *  The response contains reservation state, which can be any of these values:
 *  <ul>
 *      <li>- reserved</li>
 *      <li>- readyForPickup</li>
 *      <li>- interLibraryReservation</li>
 *      <li>- inTransit</li>
 *      <li>- other</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'
 *  .</p>
 *  The response contains reservationType, which can be any of these values:
 *  <ul>
 *      <li>- NORMAL</li>
 *      <li>- PARALLEL</li>
 *      <li>- SERIAL</li>
 *      <li>- INTER_LIBRARY</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, iit should be treated as 'normal'</p>
 *  <p>The response contains a transactionId, which links together parallel reservations.</p>
 * @summary Get all unfulfilled reservations made by the patron.
 */
export const getReservationsV2 = async (
  options?: Parameters<typeof mutator>[1]
): Promise<ReservationDetailsV2[]> => {
  return mutator<ReservationDetailsV2[]>(getGetReservationsV2Url(), {
    ...options,
    method: "GET"
  });
};

export const getGetReservationsV2QueryKey = () => {
  return [`/external/v1/agencyid/patrons/patronid/reservations/v2`] as const;
};

export const getGetReservationsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getReservationsV2>>,
  TError = ErrorType<void>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getReservationsV2>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReservationsV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReservationsV2>>
  > = ({ signal }) => getReservationsV2({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReservationsV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReservationsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getReservationsV2>>
>;
export type GetReservationsV2QueryError = ErrorType<void>;

export function useGetReservationsV2<
  TData = Awaited<ReturnType<typeof getReservationsV2>>,
  TError = ErrorType<void>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservationsV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReservationsV2>>,
          TError,
          Awaited<ReturnType<typeof getReservationsV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReservationsV2<
  TData = Awaited<ReturnType<typeof getReservationsV2>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservationsV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReservationsV2>>,
          TError,
          Awaited<ReturnType<typeof getReservationsV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReservationsV2<
  TData = Awaited<ReturnType<typeof getReservationsV2>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservationsV2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all unfulfilled reservations made by the patron.
 */

export function useGetReservationsV2<
  TData = Awaited<ReturnType<typeof getReservationsV2>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReservationsV2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReservationsV2QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAddReservationsV2Url = () => {
  return `/external/v1/agencyid/patrons/patronid/reservations/v2`;
};

/**
 *
 *  <p>Given a CreateReservationBatch, it creates a list of reservations and returns a ReservationResponse.</p>
 *  <p>The CreateReservationBatch.type indicates the reservation type of the request. If left out the request will be considered of type
 *  normal. The type can be any of the following values:</p>
 *  <ul>
 *      <li>- normal</li>
 *      <li>- parallel</li>
 *  </ul>
 *  <p>The values are subject to change.</p>
 *
 *  <p>ReservationResponse.success indicates if the reservations were created sucessfully. If any of the reservations have failed then all
 *  reservations will be failed and ReservationResponse.success will be false. If all reservations are successfully created ReservationResponse.success will be true.
 *
 *  <p></p>
 *
 *  <p>ReservationResponse.reservationResults contains details about each reservation.
 *  A ReservationResult.result has the status of a reservation and can be any of the following values:</p>
 *  <ul>
 *      <li>- success</li>
 *      <li>- patron_is_blocked</li>
 *      <li>- patron_not_found</li>
 *      <li>- already_reserved</li>
 *      <li>- already_loaned</li>
 *      <li>- material_not_loanable</li>
 *      <li>- material_not_reservable</li>
 *      <li>- material_lost</li>
 *      <li>- material_Discarded</li>
 *      <li>- loaning_profile_not_found</li>
 *      <li>- material_not_found</li>
 *      <li>- material_part_of_collection</li>
 *      <li>- not_reservable</li>
 *      <li>- no_reservable_materials</li>
 *      <li>- interlibrary_material_not_reservable</li>
 *      <li>- previously_loaned_by_homebound_patron</li>
 *      <li>- exceeds_max_reservations</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as an error.</p>
 *
 *  <p></p>
 *
 *  The reservation detail in the response contains a reservation state, which can be any of these values:
 *  <ul>
 *      <li>- reserved</li>
 *      <li>- readyForPickup</li>
 *      <li>- interLibraryReservation</li>
 *      <li>- inTransit</li>
 *      <li>- other</li>
 *  </ul>
 *  <p>The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other'.</p>
 *
 *  <p></p>
 *
 *  <p>
 *      When making a reservation of a periodical, the values to put in the PeriodicalReservation structure can be obtained
 *      from the periodical information retrieved with the Catalog service.
 *  </p>
 * @summary Create new reservations for the patron.
 */
export const addReservationsV2 = async (
  createReservationBatchV2: CreateReservationBatchV2,
  options?: Parameters<typeof mutator>[1]
): Promise<ReservationResponseV2> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<ReservationResponseV2>(getAddReservationsV2Url(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(createReservationBatchV2)
  });
};

export const getAddReservationsV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addReservationsV2>>,
    TError,
    { data: BodyType<CreateReservationBatchV2> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addReservationsV2>>,
  TError,
  { data: BodyType<CreateReservationBatchV2> },
  TContext
> => {
  const mutationKey = ["addReservationsV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addReservationsV2>>,
    { data: BodyType<CreateReservationBatchV2> }
  > = (props) => {
    const { data } = props ?? {};

    return addReservationsV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddReservationsV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof addReservationsV2>>
>;
export type AddReservationsV2MutationBody = BodyType<CreateReservationBatchV2>;
export type AddReservationsV2MutationError = ErrorType<void>;

/**
 * @summary Create new reservations for the patron.
 */
export const useAddReservationsV2 = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addReservationsV2>>,
      TError,
      { data: BodyType<CreateReservationBatchV2> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addReservationsV2>>,
  TError,
  { data: BodyType<CreateReservationBatchV2> },
  TContext
> => {
  return useMutation(getAddReservationsV2MutationOptions(options), queryClient);
};

export const getGetAvailabilityV3Url = (params: GetAvailabilityV3Params) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["recordid", "exclude"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/external/agencyid/catalog/availability/v3?${stringifiedParams}`
    : `/external/agencyid/catalog/availability/v3`;
};

/**
 *
 *  Returns an array of availability for each bibliographical record.
 * @summary Get availability of bibliographical records.
 */
export const getAvailabilityV3 = async (
  params: GetAvailabilityV3Params,
  options?: Parameters<typeof mutator>[1]
): Promise<AvailabilityV3[]> => {
  return mutator<AvailabilityV3[]>(getGetAvailabilityV3Url(params), {
    ...options,
    method: "GET"
  });
};

export const getGetAvailabilityV3QueryKey = (
  params?: GetAvailabilityV3Params
) => {
  return [
    `/external/agencyid/catalog/availability/v3`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetAvailabilityV3QueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailabilityV3>>,
  TError = ErrorType<void>
>(
  params: GetAvailabilityV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailabilityV3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAvailabilityV3QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailabilityV3>>
  > = ({ signal }) => getAvailabilityV3(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailabilityV3>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailabilityV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailabilityV3>>
>;
export type GetAvailabilityV3QueryError = ErrorType<void>;

export function useGetAvailabilityV3<
  TData = Awaited<ReturnType<typeof getAvailabilityV3>>,
  TError = ErrorType<void>
>(
  params: GetAvailabilityV3Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailabilityV3>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailabilityV3>>,
          TError,
          Awaited<ReturnType<typeof getAvailabilityV3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailabilityV3<
  TData = Awaited<ReturnType<typeof getAvailabilityV3>>,
  TError = ErrorType<void>
>(
  params: GetAvailabilityV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailabilityV3>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailabilityV3>>,
          TError,
          Awaited<ReturnType<typeof getAvailabilityV3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailabilityV3<
  TData = Awaited<ReturnType<typeof getAvailabilityV3>>,
  TError = ErrorType<void>
>(
  params: GetAvailabilityV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailabilityV3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get availability of bibliographical records.
 */

export function useGetAvailabilityV3<
  TData = Awaited<ReturnType<typeof getAvailabilityV3>>,
  TError = ErrorType<void>
>(
  params: GetAvailabilityV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailabilityV3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAvailabilityV3QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetHoldingsLogisticsV1Url = (
  params: GetHoldingsLogisticsV1Params
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["recordid", "exclude"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/external/agencyid/catalog/holdingsLogistics/v1?${stringifiedParams}`
    : `/external/agencyid/catalog/holdingsLogistics/v1`;
};

/**
 *
 *  Returns an array of holdings for each bibliographical record.
 *  The holdings lists the materials on each placement, and whether they are available on-shelf or lent out.
 * @summary Get placement holdings for bibliographical records.
 */
export const getHoldingsLogisticsV1 = async (
  params: GetHoldingsLogisticsV1Params,
  options?: Parameters<typeof mutator>[1]
): Promise<HoldingsForBibliographicalRecordLogisticsV1[]> => {
  return mutator<HoldingsForBibliographicalRecordLogisticsV1[]>(
    getGetHoldingsLogisticsV1Url(params),
    {
      ...options,
      method: "GET"
    }
  );
};

export const getGetHoldingsLogisticsV1QueryKey = (
  params?: GetHoldingsLogisticsV1Params
) => {
  return [
    `/external/agencyid/catalog/holdingsLogistics/v1`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetHoldingsLogisticsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
  TError = ErrorType<void>
>(
  params: GetHoldingsLogisticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHoldingsLogisticsV1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHoldingsLogisticsV1>>
  > = ({ signal }) =>
    getHoldingsLogisticsV1(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHoldingsLogisticsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getHoldingsLogisticsV1>>
>;
export type GetHoldingsLogisticsV1QueryError = ErrorType<void>;

export function useGetHoldingsLogisticsV1<
  TData = Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
  TError = ErrorType<void>
>(
  params: GetHoldingsLogisticsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
          TError,
          Awaited<ReturnType<typeof getHoldingsLogisticsV1>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHoldingsLogisticsV1<
  TData = Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
  TError = ErrorType<void>
>(
  params: GetHoldingsLogisticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
          TError,
          Awaited<ReturnType<typeof getHoldingsLogisticsV1>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHoldingsLogisticsV1<
  TData = Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
  TError = ErrorType<void>
>(
  params: GetHoldingsLogisticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get placement holdings for bibliographical records.
 */

export function useGetHoldingsLogisticsV1<
  TData = Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
  TError = ErrorType<void>
>(
  params: GetHoldingsLogisticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHoldingsLogisticsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetHoldingsLogisticsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetFeesV2Url = (params: GetFeesV2Params) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/external/agencyid/patron/patronid/fees/v2?${stringifiedParams}`
    : `/external/agencyid/patron/patronid/fees/v2`;
};

/**
 *
 *  Returns array of fees.
 *  <p>If the fee covers loaned materials, information about the materials is returned.
 *  Each fee in the response includes a 'type', which is used to distinguish between different types of
 *  fees.</p>
 *  <p>If the material exists no more, which is the case for fees that are related to closed interlibraryloans,
 *  then the fee is still returned, but without material information</p>
 *  The list of available types currently is
 *  <ul>
 *  <li>fee</li>
 *  <li>compensation</li>
 *  </ul>
 *  <p>While the type can be used by client systems to look up a suitable display message for the end user, it is
 *  important that unrecognized types are treated as 'other'.</p>
 * @summary List of fees in FBS for the patron with all available information about the fee.
 */
export const getFeesV2 = async (
  params: GetFeesV2Params,
  options?: Parameters<typeof mutator>[1]
): Promise<FeeV2[]> => {
  return mutator<FeeV2[]>(getGetFeesV2Url(params), {
    ...options,
    method: "GET"
  });
};

export const getGetFeesV2QueryKey = (params?: GetFeesV2Params) => {
  return [
    `/external/agencyid/patron/patronid/fees/v2`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetFeesV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getFeesV2>>,
  TError = ErrorType<void>
>(
  params: GetFeesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeesV2>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeesV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeesV2>>> = ({
    signal
  }) => getFeesV2(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeesV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFeesV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeesV2>>
>;
export type GetFeesV2QueryError = ErrorType<void>;

export function useGetFeesV2<
  TData = Awaited<ReturnType<typeof getFeesV2>>,
  TError = ErrorType<void>
>(
  params: GetFeesV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeesV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesV2>>,
          TError,
          Awaited<ReturnType<typeof getFeesV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeesV2<
  TData = Awaited<ReturnType<typeof getFeesV2>>,
  TError = ErrorType<void>
>(
  params: GetFeesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeesV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesV2>>,
          TError,
          Awaited<ReturnType<typeof getFeesV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeesV2<
  TData = Awaited<ReturnType<typeof getFeesV2>>,
  TError = ErrorType<void>
>(
  params: GetFeesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeesV2>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List of fees in FBS for the patron with all available information about the fee.
 */

export function useGetFeesV2<
  TData = Awaited<ReturnType<typeof getFeesV2>>,
  TError = ErrorType<void>
>(
  params: GetFeesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFeesV2>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeesV2QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateV9Url = () => {
  return `/external/agencyid/patrons/v9`;
};

/**
 *
 *  When a patron doesn't have a patron account in the library system, but logs in using a trusted authentication
 *  source (e.g NemId), the patron account can be created using this service. Name and address will be automatically
 *  fetched from configured person registry, and cannot be supplied by the client. If the configured person registry is not authorized to
 *  provide information about the patron, then response message 404 will be sent back
 *  <p>Multiple email addresses and phone numbers can be stored for a patron.</p>
 *  <p>If multiple email addresses are supplied having receiveNotification as true, then only one of them will be randomly stored
 *  as preferred and the rest will be stored as not preferred.</p>
 *  <p>If multiple phone numbers are supplied having receiveNotification as true, then only one of them will be randomly stored
 *  as preferred and the rest will be stored as not preferred.</p>
 *  <p>
 *  This version includes a possibility of including a BlockStatus in the request.
 *  The reason of the blockstatus must be one of the following one-letter choices
 *  <ul>
 *  <li>- 'O': library card stolen</li></li>
 *  <li>- 'F': extended exclusion</li>
 *  <li>- 'U': exclusion</li>
 *  <li>- 'S': blocked by self service automaton</li>
 *  <li>- 'W': self created at website</li>
 *  <li>- 'E': maximum amount of allowed debt exceeded</li>
 *  <li>- 'D': deceased</li>
 *  </ul>
 *
 *  <p>If the request includes a blockstatus for the patron, and the blockedSince date is not given or in the wrong format, or the blockedReason is not one of the one-letter choices shown above, then response message 400 will be sent back.
 *  </p>
 * @summary Create a new patron who is a person.
 */
export const createV9 = async (
  createPatronRequestV7: CreatePatronRequestV7,
  options?: Parameters<typeof mutator>[1]
): Promise<AuthenticatedPatronV10> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<AuthenticatedPatronV10>(getCreateV9Url(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(createPatronRequestV7)
  });
};

export const getCreateV9MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createV9>>,
    TError,
    { data: BodyType<CreatePatronRequestV7> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createV9>>,
  TError,
  { data: BodyType<CreatePatronRequestV7> },
  TContext
> => {
  const mutationKey = ["createV9"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createV9>>,
    { data: BodyType<CreatePatronRequestV7> }
  > = (props) => {
    const { data } = props ?? {};

    return createV9(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateV9MutationResult = NonNullable<
  Awaited<ReturnType<typeof createV9>>
>;
export type CreateV9MutationBody = BodyType<CreatePatronRequestV7>;
export type CreateV9MutationError = ErrorType<void>;

/**
 * @summary Create a new patron who is a person.
 */
export const useCreateV9 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createV9>>,
      TError,
      { data: BodyType<CreatePatronRequestV7> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createV9>>,
  TError,
  { data: BodyType<CreatePatronRequestV7> },
  TContext
> => {
  return useMutation(getCreateV9MutationOptions(options), queryClient);
};

export const getCreateWithGuardianUrl = () => {
  return `/external/agencyid/patrons/withGuardian/v1`;
};

/**
 *
 *
 *  Returns the id of the patron if the request succeeds.
 *  Name and address will be automatically fetched from the CPR-Registry.
 *  <p>If the CPR-Registry is not authorized to provide information about the patron, then response message 404 will be sent back.</p>
 *  <p>If the supplied cpr number of the patron equals that of the guardian, then response message 400 will be sent back.</p>
 *  <p>If the email of the guardian is invalid, then response message 400 will be sent back.</p>
 *  <p>If an email or phone number for the patron is supplied and it is invalid, then response message 400 will be sent back.</p>
 *  <p>In case of a successful creation of the patron, a confirmation email is sent to the guardian.
 *  In case of failure an email is sent to guardian stating the creation failed.</p>
 * @summary Creates a person patron with a guardian (eg A financial responsible).
 */
export const createWithGuardian = async (
  patronWithGuardianRequest: PatronWithGuardianRequest,
  options?: Parameters<typeof mutator>[1]
): Promise<number> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<number>(getCreateWithGuardianUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(patronWithGuardianRequest)
  });
};

export const getCreateWithGuardianMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWithGuardian>>,
    TError,
    { data: BodyType<PatronWithGuardianRequest> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWithGuardian>>,
  TError,
  { data: BodyType<PatronWithGuardianRequest> },
  TContext
> => {
  const mutationKey = ["createWithGuardian"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWithGuardian>>,
    { data: BodyType<PatronWithGuardianRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createWithGuardian(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWithGuardianMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWithGuardian>>
>;
export type CreateWithGuardianMutationBody =
  BodyType<PatronWithGuardianRequest>;
export type CreateWithGuardianMutationError = ErrorType<void>;

/**
 * @summary Creates a person patron with a guardian (eg A financial responsible).
 */
export const useCreateWithGuardian = <
  TError = ErrorType<void>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createWithGuardian>>,
      TError,
      { data: BodyType<PatronWithGuardianRequest> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createWithGuardian>>,
  TError,
  { data: BodyType<PatronWithGuardianRequest> },
  TContext
> => {
  return useMutation(
    getCreateWithGuardianMutationOptions(options),
    queryClient
  );
};

export const getUpdateGuardianUrl = () => {
  return `/external/agencyid/patrons/withGuardian/v1`;
};

/**
 *
 *  If the person doesn't have a guardian, a new one is created with the information provided.
 *
 *  Returns the id of the patron if the request succeeds.
 *  Name and address will be automatically fetched from the CPR-Registry.
 *  <p>If the CPR-Registry is not authorized to provide information about the patron and guardian, then response message 404 will be sent back.</p>
 *  <p>If the supplied cpr number of the patron equals that of the guardian, then response message 400 will be sent back.</p>
 *  <p>If the email of the guardian is invalid, then response message 400 will be sent back.</p>
 *  <p>In case of a successful update of the guardian, a confirmation email is sent to the guardian.
 *  In case of failure an email is sent to guardian stating the update failed.</p>
 * @summary Updates a person patron's guardian (eg A financial responsible).
 */
export const updateGuardian = async (
  updateGuardianRequest: UpdateGuardianRequest,
  options?: Parameters<typeof mutator>[1]
): Promise<number> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<number>(getUpdateGuardianUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(updateGuardianRequest)
  });
};

export const getUpdateGuardianMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGuardian>>,
    TError,
    { data: BodyType<UpdateGuardianRequest> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGuardian>>,
  TError,
  { data: BodyType<UpdateGuardianRequest> },
  TContext
> => {
  const mutationKey = ["updateGuardian"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGuardian>>,
    { data: BodyType<UpdateGuardianRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateGuardian(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGuardianMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGuardian>>
>;
export type UpdateGuardianMutationBody = BodyType<UpdateGuardianRequest>;
export type UpdateGuardianMutationError = ErrorType<void>;

/**
 * @summary Updates a person patron's guardian (eg A financial responsible).
 */
export const useUpdateGuardian = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateGuardian>>,
      TError,
      { data: BodyType<UpdateGuardianRequest> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateGuardian>>,
  TError,
  { data: BodyType<UpdateGuardianRequest> },
  TContext
> => {
  return useMutation(getUpdateGuardianMutationOptions(options), queryClient);
};

export const getRenewLoansV2Url = () => {
  return `/external/agencyid/patrons/patronid/loans/renew/v2`;
};

/**
 *
 *  Returns an array of the updated loans.
 *  <p>
 *  If the materials could not be renewed, the return date will be unchanged.
 *  </p>
 *  <p>
 *  The response field renewalStatus will contain a list of one or more of these values:
 *  <ul>
 *  <li>- renewed</li>
 *  <li>- deniedReserved</li>
 *  <li>- deniedMaxRenewalsReached</li>
 *  <li>- deniedLoanerIsBlocked</li>
 *  <li>- deniedMaterialIsNotLoanable</li>
 *  <li>- deniedMaterialIsNotFound</li>
 *  <li>- deniedLoanerNotFound</li>
 *  <li>- deniedLoaningProfileNotFound</li>
 *  <li>- deniedOtherReason</li>
 *  </ul>
 *  <p>
 *  If any other value is encountered then it must be treated as 'deniedOtherReason'.
 *  </p>
 *  The response contains the field loanDetails.loanType, which can be any of these values:
 *  <ul>
 *  <li>- loan</li>
 *  <li>- interLibraryLoan</li>
 *  </ul>
 *  <p>
 *  The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other' .
 *  </p>
 * @summary Renew loans.
 */
export const renewLoansV2 = async (
  renewLoansV2Body: number[],
  options?: Parameters<typeof mutator>[1]
): Promise<RenewedLoanV2[]> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<RenewedLoanV2[]>(getRenewLoansV2Url(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(renewLoansV2Body)
  });
};

export const getRenewLoansV2MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewLoansV2>>,
    TError,
    { data: BodyType<number[]> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renewLoansV2>>,
  TError,
  { data: BodyType<number[]> },
  TContext
> => {
  const mutationKey = ["renewLoansV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renewLoansV2>>,
    { data: BodyType<number[]> }
  > = (props) => {
    const { data } = props ?? {};

    return renewLoansV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenewLoansV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof renewLoansV2>>
>;
export type RenewLoansV2MutationBody = BodyType<number[]>;
export type RenewLoansV2MutationError = ErrorType<void>;

/**
 * @summary Renew loans.
 */
export const useRenewLoansV2 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renewLoansV2>>,
      TError,
      { data: BodyType<number[]> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof renewLoansV2>>,
  TError,
  { data: BodyType<number[]> },
  TContext
> => {
  return useMutation(getRenewLoansV2MutationOptions(options), queryClient);
};

export const getGetLoansV2Url = () => {
  return `/external/agencyid/patrons/patronid/loans/v2`;
};

/**
 *
 *  Returns an array of loans.
 *  <p>
 *  </p>
 *  If a loan is not renewable then the field renewalStatus will contain a list of one or more of these values:
 *  <ul>
 *  <li>- deniedReserved</li>
 *  <li>- deniedMaxRenewalsReached</li>
 *  <li>- deniedLoanerIsBlocked</li>
 *  <li>- deniedMaterialIsNotLoanable</li>
 *  <li>- deniedMaterialIsNotFound</li>
 *  <li>- deniedLoanerNotFound</li>
 *  <li>- deniedLoaningProfileNotFound</li>
 *  <li>- deniedOtherReason</li>
 *  </ul>
 *  <p>
 *  If any other value is encountered then it must be treated as 'deniedOtherReason'.
 *  </p>
 *  The response contains the field loanDetails.loanType, which can be any of these values:
 *  <ul>
 *  <li>- loan</li>
 *  <li>- interLibraryLoan</li>
 *  </ul>
 *  <p>
 *  The values are subject to change. If an unrecognized value is encountered, it should be treated as 'other' .
 *  </p>
 *  <p>
 *  NOTE: Cicero can decide to skip evaluation of the returned loans to minimize response time for loaners with
 *  many loans. In that case isRenewable will have the value true, as if it were a successful validation.
 *  </p>
 * @summary Get list of current loans by the patron.
 */
export const getLoansV2 = async (
  options?: Parameters<typeof mutator>[1]
): Promise<LoanV2[]> => {
  return mutator<LoanV2[]>(getGetLoansV2Url(), {
    ...options,
    method: "GET"
  });
};

export const getGetLoansV2QueryKey = () => {
  return [`/external/agencyid/patrons/patronid/loans/v2`] as const;
};

export const getGetLoansV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getLoansV2>>,
  TError = ErrorType<void>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoansV2>>, TError, TData>
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoansV2QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoansV2>>> = ({
    signal
  }) => getLoansV2({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoansV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLoansV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoansV2>>
>;
export type GetLoansV2QueryError = ErrorType<void>;

export function useGetLoansV2<
  TData = Awaited<ReturnType<typeof getLoansV2>>,
  TError = ErrorType<void>
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoansV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansV2>>,
          TError,
          Awaited<ReturnType<typeof getLoansV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoansV2<
  TData = Awaited<ReturnType<typeof getLoansV2>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoansV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansV2>>,
          TError,
          Awaited<ReturnType<typeof getLoansV2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoansV2<
  TData = Awaited<ReturnType<typeof getLoansV2>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoansV2>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get list of current loans by the patron.
 */

export function useGetLoansV2<
  TData = Awaited<ReturnType<typeof getLoansV2>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoansV2>>, TError, TData>
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLoansV2QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPatronInformationByPatronIdV4Url = () => {
  return `/external/agencyid/patrons/patronid/v4`;
};

/**
 *
 *  <p></p>
 *  If a patron is blocked the reason is available as a code:
 *  <ul>
 *      <li>- 'O': library card stolen</li>
 *      <li>- 'U': exclusion</li>
 *      <li>- 'F': extended exclusion</li>
 *      <li>- 'S': blocked by self service automaton</li>
 *      <li>- 'W': self created at website</li>
 *  </ul>
 *  <p>The codes are informational, and can be used for looking up end user messages by the client system. However,
 *  the list is subject to change at any time, so any unexpected values should be interpreted as 'other reason'.</p>
 * @summary Returns the patron details
 */
export const getPatronInformationByPatronIdV4 = async (
  options?: Parameters<typeof mutator>[1]
): Promise<AuthenticatedPatronV8> => {
  return mutator<AuthenticatedPatronV8>(
    getGetPatronInformationByPatronIdV4Url(),
    {
      ...options,
      method: "GET"
    }
  );
};

export const getGetPatronInformationByPatronIdV4QueryKey = () => {
  return [`/external/agencyid/patrons/patronid/v4`] as const;
};

export const getGetPatronInformationByPatronIdV4QueryOptions = <
  TData = Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
  TError = ErrorType<void>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof mutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatronInformationByPatronIdV4QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>
  > = ({ signal }) =>
    getPatronInformationByPatronIdV4({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatronInformationByPatronIdV4QueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>
>;
export type GetPatronInformationByPatronIdV4QueryError = ErrorType<void>;

export function useGetPatronInformationByPatronIdV4<
  TData = Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
  TError = ErrorType<void>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
          TError,
          Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatronInformationByPatronIdV4<
  TData = Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
          TError,
          Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatronInformationByPatronIdV4<
  TData = Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the patron details
 */

export function useGetPatronInformationByPatronIdV4<
  TData = Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
  TError = ErrorType<void>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatronInformationByPatronIdV4>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatronInformationByPatronIdV4QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateV4Url = () => {
  return `/external/agencyid/patrons/patronid/v4`;
};

/**
 *
 *  The name and address cannot be supplied by the client. If the CPR-Registry is not authorized to provide
 *  information about the patron, then the name and address will not be updated.
 *  <p>It is possible to either update just the pincode, update just some patron settings, or update both.</p>
 *  <p></p>
 *  If a patron is blocked the reason is available as a code:
 *  <ul>
 *      <li>- 'O': library card stolen</li>
 *      <li>- 'U': exclusion</li>
 *      <li>- 'F': extended exclusion</li>
 *      <li>- 'S': blocked by self service automaton</li>
 *      <li>- 'W': self created at website</li>
 *  </ul>
 *  <p>The codes are informational, and can be used for looking up end user messages by the client system. However,
 *  the list is subject to change at any time, so any unexpected values should be interpreted as 'other reason'.</p>
 * @summary Update information about the patron.
 */
export const updateV4 = async (
  updatePatronRequestV3: UpdatePatronRequestV3,
  options?: Parameters<typeof mutator>[1]
): Promise<AuthenticatedPatronV4> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<AuthenticatedPatronV4>(getUpdateV4Url(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(updatePatronRequestV3)
  });
};

export const getUpdateV4MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateV4>>,
    TError,
    { data: BodyType<UpdatePatronRequestV3> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateV4>>,
  TError,
  { data: BodyType<UpdatePatronRequestV3> },
  TContext
> => {
  const mutationKey = ["updateV4"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateV4>>,
    { data: BodyType<UpdatePatronRequestV3> }
  > = (props) => {
    const { data } = props ?? {};

    return updateV4(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateV4MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateV4>>
>;
export type UpdateV4MutationBody = BodyType<UpdatePatronRequestV3>;
export type UpdateV4MutationError = ErrorType<void>;

/**
 * @summary Update information about the patron.
 */
export const useUpdateV4 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateV4>>,
      TError,
      { data: BodyType<UpdatePatronRequestV3> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateV4>>,
  TError,
  { data: BodyType<UpdatePatronRequestV3> },
  TContext
> => {
  return useMutation(getUpdateV4MutationOptions(options), queryClient);
};

export const getUpdateV8Url = () => {
  return `/external/agencyid/patrons/patronid/v8`;
};

/**
 *
 *  The name and address cannot be supplied by the client. If the configured person registry is not authorized to provide
 *  information about the patron, then the name and address will not be updated.
 *  <p>It is possible to either update just the pincode, update just some patron settings, or update both.</p>
 *  <p>Multiple email addresses and phone numbers can be stored for a patron.</p>
 *  <p>If multiple email addresses are supplied having receiveNotification as true, then only one of them will be randomly stored
 *  as preferred and the rest will be stored as not preferred.</p>
 *  <p>If multiple phone numbers are supplied having receiveNotification as true, then only one of them will be randomly stored
 *  as preferred and the rest will be stored as not preferred.</p>
 *  <p></p>
 *  If a patron is blocked the reason is available as a code:
 *  <ul>
 *      <li>- 'O': library card stolen</li>
 *      <li>- 'U': exclusion</li>
 *      <li>- 'F': extended exclusion</li>
 *      <li>- 'S': blocked by self service automaton</li>
 *      <li>- 'W': self created at website</li>
 *  </ul>
 *  <p>The codes are informational, and can be used for looking up end user messages by the client system. However,
 *  the list is subject to change at any time, so any unexpected values should be interpreted as 'other reason'.</p>
 * @summary Update information about the patron.
 */
export const updateV8 = async (
  updatePatronRequestV6: UpdatePatronRequestV6,
  options?: Parameters<typeof mutator>[1]
): Promise<void> => {
  const getHeaders = (h?: HeadersInit | Headers): Record<string, string> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return mutator<void>(getUpdateV8Url(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(updatePatronRequestV6)
  });
};

export const getUpdateV8MutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateV8>>,
    TError,
    { data: BodyType<UpdatePatronRequestV6> },
    TContext
  >;
  request?: SecondParameter<typeof mutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateV8>>,
  TError,
  { data: BodyType<UpdatePatronRequestV6> },
  TContext
> => {
  const mutationKey = ["updateV8"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateV8>>,
    { data: BodyType<UpdatePatronRequestV6> }
  > = (props) => {
    const { data } = props ?? {};

    return updateV8(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateV8MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateV8>>
>;
export type UpdateV8MutationBody = BodyType<UpdatePatronRequestV6>;
export type UpdateV8MutationError = ErrorType<void>;

/**
 * @summary Update information about the patron.
 */
export const useUpdateV8 = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateV8>>,
      TError,
      { data: BodyType<UpdatePatronRequestV6> },
      TContext
    >;
    request?: SecondParameter<typeof mutator>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateV8>>,
  TError,
  { data: BodyType<UpdatePatronRequestV6> },
  TContext
> => {
  return useMutation(getUpdateV8MutationOptions(options), queryClient);
};
